import { render } from "./EstatisticasFilters.vue?vue&type=template&id=0037d6b9"
import script from "./EstatisticasFilters.vue?vue&type=script&lang=js"
export * from "./EstatisticasFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__